// extracted by mini-css-extract-plugin
export default {"body":"ActivityPage_body__2kjc8","fullWidth":"ActivityPage_fullWidth__oRUNn","tabs":"ActivityPage_tabs__bTyuM"};